import { render, staticRenderFns } from "./Farmland.vue?vue&type=template&id=07360a42&scoped=true&"
import script from "./Farmland.vue?vue&type=script&lang=js&"
export * from "./Farmland.vue?vue&type=script&lang=js&"
import style0 from "./Farmland.vue?vue&type=style&index=0&id=07360a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07360a42",
  null
  
)

export default component.exports